module.exports = __webpack_public_path__ + "static/media/balance_50000_75000.7441173c.png";